import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import * as yup from "yup";
import { validCnpj, validCpf } from "../../helpers/ValidateCpfCnpj";
import {
  COURTESY_JUSSUB_ALLOWED_DAYS,
  COURTESY_MIN_DAYS,
  COURTESY_MAX_DAYS
} from "../../constants/courtesy";
import Step1 from "./Steps/Step1";
import PixModal from "../ClienteDados/components/PixModal";
import { useAdminClientesSubmit } from "./adminClientes.bootstrap.hook";

export default function AdminClientes(props) {
  const [step, setStep] = useState(0);

  const dispatch = useDispatch();
  const { onSubmit, useJusSub, pixModalData, closePixModal } = useAdminClientesSubmit();

  const validaDocument = (document_number) => {
    const documentNumber = document_number?.replace(/\D/g, "");
    return validCpf(documentNumber) || validCnpj(documentNumber);
  };

  const initialValues = {
    oab: "",
    name: "",
    email: "",
    address: "",
    address_number: "",
    address_complement: "",
    phone: "",
    city: null,
    state: null,
    oab_state: null,
    profession: null,
    type: "",
    client_type: "b2c",
    document_number: "",
    postal_code: "",
    district: "",
    plan: null,
    provider: { id: "pagarme_v5", label: "PSP 2.0" },
    is_courtesy: false,
    courtesy_product: null,
    courtesy_duration_type: "activeDays",
    courtesy_duration: ""
  };

  useEffect(() => {
    dispatch({ type: "LOAD_STATES" });
    dispatch({ type: "LOAD_PROFESSIONS" });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const step1Validation = yup.object().shape({
    name: yup.string().trim().required("O campo nome é obrigatório!"),
    oab: yup.string().when("profession", {
      is: value =>
        JSON.stringify(value) === JSON.stringify({ id: 1, name: "Advogado" }),
      then: yup.string().nullable()
    }),
    type: yup.string().required("O campo tipo é obrigatório!"),
    client_type: yup
      .string()
      .oneOf(["b2c", "b2b"], "Segmento inválido.")
      .required("O campo segmento é obrigatório!"),
    email: yup.string().required("O campo e-mail é obrigatório!"),
    phone: yup
      .string()
      .matches(
        /^\([1-9]{2}\) (?:[2-8]|9[1-9])[0-9]{3}\-[0-9]{4}$/,
        "Telefone inválido."
      ).required("O campo telefone é obrigatório!"),
    city: yup
      .object()
      .required("O campo cidade é obrigatório!"),
    state: yup.object().required("O campo estado é obrigatório!"),
    postal_code: yup
      .string()
      .required("O campo CEP é obrigatório!"),
    district: yup.string().required("O campo bairro é obrigatório!"),
    address: yup.string().required("O campo endereço é obrigatório!"),
    address_number: yup
      .string()
      .required("O campo número é obrigatório!"),
    address_complement: yup.string().nullable(),
    oab_state: yup
      .object()
      .nullable()
      .when("profession", {
        is: value =>
          JSON.stringify(value) === JSON.stringify({ id: 1, name: "Advogado" }),
        then: yup.object().nullable()
      }),
    profession: yup
      .object()
      .nullable()
      .required("O campo profissão é obrigatório!"),
    document_number: yup.string().test(
      "document_number",
      "CPF/CNPJ inválido",
      function (value) {
        return validaDocument(value);
      }
    ).required("O campo CPF/CNPJ é obrigatório!"),
    plan: yup
      .object()
      .nullable()
      .required("O campo plano é obrigatório!"),
    provider: yup
      .mixed()
      .when("is_courtesy", {
        is: false,
        then: yup.string().required("O provedor de pagamento é obrigatório!")
      }),
    is_courtesy: yup.boolean(),
    courtesy_product: yup
      .string()
      .nullable()
      .when("is_courtesy", {
        is: true,
        then: yup.string().required("O tipo de liberação é obrigatório!")
      }),
    courtesy_duration: yup.mixed().when("is_courtesy", {
      is: true,
      then: useJusSub
        ? yup
            .number()
            .typeError("A duração da cortesia é obrigatória!")
            .oneOf(
              COURTESY_JUSSUB_ALLOWED_DAYS,
              "A duração da cortesia é obrigatória!"
            )
        : yup
            .number()
            // vazio = duração padrão do plano
            .transform((value, originalValue) =>
              originalValue === "" ? undefined : value
            )
            .typeError(
              `A duração deve ser um número inteiro entre ${COURTESY_MIN_DAYS} e ${COURTESY_MAX_DAYS} dias.`
            )
            .integer(
              `A duração deve ser um número inteiro entre ${COURTESY_MIN_DAYS} e ${COURTESY_MAX_DAYS} dias.`
            )
            .min(
              COURTESY_MIN_DAYS,
              `A duração deve ser de no mínimo ${COURTESY_MIN_DAYS} dia.`
            )
            .max(
              COURTESY_MAX_DAYS,
              `A duração deve ser de no máximo ${COURTESY_MAX_DAYS} dias.`
            )
    })
  });

  const schemaArray = [step1Validation];
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    onSubmit: (values, helpers) => {
      const { setSubmitting, resetForm } = helpers;
      const sanitizedValues = {
        ...values,
        name: values.name?.trim(),
        email: values.email?.trim()
      };

      onSubmit(sanitizedValues, { setSubmitting, resetForm });
    },
    validationSchema: schemaArray[step]
  });

  return (
    <>
      <Step1 step={step} setStep={setStep} formik={formik} useJusSub={useJusSub} />
      {pixModalData && (
        <PixModal
          setOpen={closePixModal}
          pixCode={pixModalData.pixCode}
          pixQR={pixModalData.pixQR}
          pixTimer={pixModalData.pixTimer}
          hideStatusCheck
        />
      )}
    </>
  );
}
